import React, { useEffect, useState } from "react";
import {
  getProductListByModel,
  toggleProductStatus,
  createSpareDiscount,
  getMenu1,
} from "../../../services/apiService";

const CreateSpareDiscount = () => {
  const [modelNo, setModelNo] = useState("");
  const [products, setProducts] = useState([]);
  const [menuData, setMenuData] = useState([]);

  // Search products
  const handleSearch = async () => {
    try {
      const res = await getProductListByModel(modelNo);
      const sparesArray = res.data?.[0]?.Spares || [];
      setProducts(sparesArray);
    } catch (err) {
      console.error(err);
      setProducts([]);
    }
  };

  // Toggle Active/Inactive
  const handleToggle = async (id, currentStatus) => {
    try {
      await toggleProductStatus(id, !currentStatus);
      setProducts((prev) =>
        prev.map((p) =>
          p.productid === id ? { ...p, active: !currentStatus } : p,
        ),
      );
    } catch (err) {
      console.error("Failed to toggle status", err);
    }
  };

  // Create Spare Discount
  const handleCreateDiscount = async (productId) => {
    const payload = {
      product_id: productId,
      discount: 10, // You can make this dynamic later
    };
    try {
      await createSpareDiscount(payload);
      alert("Spare discount created!");
    } catch (err) {
      console.error(err);
      alert("Error creating discount");
    }
  };
  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const data = await getMenu1();
        setMenuData(data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchMenu();
  }, []);

  // Table cell styles
  const styles = {
    input: {
      padding: "10px 12px",
      width: "240px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      fontSize: "14px",
      outline: "none",
    },

    searchButton: {
      padding: "10px 18px",
      backgroundColor: "#005487", // blue
      color: "#fff",
      border: "none",
      borderRadius: "6px",
      fontSize: "14px",
      fontWeight: "500",
      cursor: "pointer",
      transition: "all 0.2s ease",
    },

    table: {
      width: "100%",
      borderCollapse: "collapse",
      backgroundColor: "#fff",
      borderRadius: "8px",
      overflow: "hidden",
      boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
    },

    th: {
      padding: "12px",
      backgroundColor: "#f8fafc",
      color: "#334155",
      fontSize: "13px",
      fontWeight: "600",
      textAlign: "center",
      borderBottom: "1px solid #e5e7eb",
    },

    td: {
      padding: "12px",
      fontSize: "13px",
      color: "#475569",
      textAlign: "center",
      borderBottom: "1px solid #e5e7eb",
    },

    actionBtn: {
      padding: "6px 12px",
      backgroundColor: "#16a34a",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      fontSize: "12px",
      cursor: "pointer",
      transition: "0.2s ease",
      marginRight: "10px",
    },
  };
  const modelOptions = menuData.flatMap((category) =>
    (category.Subcategory || []).flatMap((sub) =>
      (sub.dtls || []).map((item) => ({
        value: item.modelno,
        label: item.modelno,
        productid: item.productid,
      })),
    ),
  );
  return (
    <div style={{ padding: "20px" }}>
      <h3>Spare Product List</h3>

      <div style={{ marginBottom: "15px" }}>
        <input
          type="text"
          list="model-options"
          placeholder="Enter or select model number"
          value={modelNo}
          onChange={(e) => setModelNo(e.target.value)}
          style={styles.input}
        />

        <datalist id="model-options">
          {modelOptions.map((item) => (
            <option key={item.productid} value={item.value} />
          ))}
        </datalist>
        <button onClick={handleSearch} style={styles.searchButton}>
          Search
        </button>
      </div>

      <table width="100%" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={styles.th}>ID</th>
            <th style={styles.th}>Model No</th>
            <th style={styles.th}>Name</th>
            <th style={styles.th}>Status</th>
            <th style={styles.th}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.length === 0 ? (
            <tr>
              <td colSpan="5" style={styles.td}>
                No spares found
              </td>
            </tr>
          ) : (
            products.map((p) => (
              <tr key={p.productid}>
                <td style={styles.td}>{p.productid}</td>
                <td style={styles.td}>{p.mainmodelno}</td>
                <td style={styles.td}>{p.displaymodelno}</td>
                <td style={styles.td}>
                  {/* Toggle Switch */}
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={p.active}
                      onChange={() => handleToggle(p.productid, p.active)}
                    />
                    <span className="slider"></span>
                  </label>
                </td>
                <td style={styles.td}>
                  <button
                    onClick={() => handleCreateDiscount(p.productid)}
                    style={styles.actionBtn}
                  >
                    Add
                  </button>
                  <button
                    onClick={() => handleCreateDiscount(p.productid)}
                    style={styles.actionBtn}
                  >
                    Edit
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Toggle Switch Styles */}
      <style>
        {`
          .switch {
            position: relative;
            display: inline-block;
            width: 50px;
            height: 24px;
          }
          .switch input { display: none; }
          .slider {
            position: absolute;
            cursor: pointer;
            top: 0; left: 0; right: 0; bottom: 0;
            background-color: #ccc;
            transition: 0.4s;
            border-radius: 24px;
          }
          .slider:before {
            position: absolute;
            content: "";
            height: 18px;
            width: 18px;
            left: 3px;
            bottom: 3px;
            background-color: white;
            transition: 0.4s;
            border-radius: 50%;
          }
          input:checked + .slider {
            background-color: #4caf50;
          }
          input:checked + .slider:before {
            transform: translateX(26px);
          }
        `}
      </style>
    </div>
  );
};

export default CreateSpareDiscount;
